import React from "react";
import * as Styled from "./styles.module";
import {
  chatDateFormat,
  convertToUsaDateFormat,
  convertToUsaTimeFormat,
} from "../../../helpers/DateHelper";

interface ITechniciansContactsListItemProps {
  contactData: any;
  incomingCounter: number;
  onClick?(e: any): void;
}

type Props = ITechniciansContactsListItemProps;

export class TechniciansContactsListItem extends React.Component<Props> {
  state: any = {};

  render() {
    const avatarUrl = this.props.contactData.avatar;
    const active = !!this.props.contactData.active;
    const date = this.props.contactData?.original?.msg_date || "";
    const media = this.props.contactData?.original?.msg_media || [];
    const fullDate = date
      ? `${convertToUsaDateFormat(date)} ${convertToUsaTimeFormat(date)}`
      : "";
    const shortDate = chatDateFormat(date);
    const incomingCounter = this.props.incomingCounter || 0;

    let firstletter = this.props.contactData?.original?.first_name || "-";
    let lastletter = this.props.contactData?.original?.last_name || "-";

    firstletter = firstletter[0]?.toUpperCase();
    lastletter = lastletter[0]?.toUpperCase();

    return (
      <Styled.TechniciansContactsListItemStyles
        onClick={(e) => this.props.onClick && this.props.onClick(e)}
        className={`cli__item ${active ? "--active" : ""}`}
      >
        <div className={`cli__status ${active ? "--active" : ""}`}></div>
        <div className="cli__meta">
          <div className="cli__avatar typo typo-text-14">
            {avatarUrl ? (
              <img src={avatarUrl} width="40" height="40" />
            ) : (
              <span className="cli__avatar-text">{`${firstletter}${lastletter}`}</span>
            )}
          </div>
          <div className="cli__name typo typo-text-14">
            {this.props.contactData.name}
          </div>
          <div className="cli__datetime typo typo-text-12" title={fullDate}>
            {shortDate}
          </div>
        </div>
        <div className="cli__message typo typo-text-12">
          {media && media.length > 0
            ? "<Image>"
            : this.props.contactData.message}
          {/* Test message Test message Test message Test message Test message Test message Test message */}
        </div>
        {incomingCounter > 0 ? (
          <Styled.Notifier>{incomingCounter}</Styled.Notifier>
        ) : (
          ""
        )}
      </Styled.TechniciansContactsListItemStyles>
    );
  }
}
